
export default function ButtonLayoutDesign(autoOpen: any) {

    return (
        <>


            <div className='ws-12 landing'>

                <div className="ws-12 pm plxl">

                    <h1>Button</h1>


                    <div className="ws-12 pm">
                        <h2>Button -with icon only</h2>

                    </div>

                    <div className="ws-12 pm">

                        <h2>Button -with icon and text</h2>
                    </div>
                </div>
            </div>
        </>
    )

}